import React from 'react';
import PropTypes from 'prop-types';
import { OrderedMap } from 'immutable';

import Brand from 'models/brand';

import Vehicle from 'components/account/saved-vehicles/vehicle';
import AccountHeadline from 'components/common/account/account-headline';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  vehicles: PropTypes.instanceOf(OrderedMap).isRequired,
  addNewVehicle: PropTypes.func.isRequired,
  editVehicle: PropTypes.func.isRequired,
  deleteVehicle: PropTypes.func.isRequired,
  setDefaultVehicle: PropTypes.func.isRequired,
  defaultVehicleId: PropTypes.number,
  selectedVehicleId: PropTypes.string,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
  defaultVehicleId: null,
  selectedVehicleId: null,
};

const SavedVehicles = ({
  brand,
  vehicles,
  addNewVehicle,
  editVehicle,
  deleteVehicle,
  setDefaultVehicle,
  defaultVehicleId,
  selectedVehicleId,
  app,
  trackEvent }) => {
  const vehicleCards = vehicles.map(vehicle => (
    <Vehicle
      key={`vehicle-${vehicle.id}`}
      vehicle={vehicle}
      deleteVehicle={deleteVehicle}
      editVehicle={editVehicle}
      setDefaultVehicle={setDefaultVehicle}
      defaultVehicleId={defaultVehicleId}
    />
  )).toArray();
  vehicleCards.push(
    <div className="col-md-4 col-xs-12">
      <div className="clickable btn-cutout btn-blue btn-boxy text-weight-medium" onClick={addNewVehicle}>
        <div className="btn-boxy-text h5-sg">
          <span className="iconified-font iconified-plus" /> ADD NEW
        </div>
      </div>
    </div>,
  );
  const cards = [];
  for (let i = 0; i < vehicleCards.length; i += 3) {
    cards.push(<div className="row" key={`v-row-${i + 1}`}>
      {vehicleCards[i]}
      {vehicleCards[i + 1]}
      {vehicleCards[i + 2]}
    </div>);
  }

  return (
    <div>
      <AccountHeadline brand={brand} headline="MANAGE SAVED VEHICLES" app={app} trackEvent={trackEvent} />
      <div className="row with-bottom-margin-2x">
        <div className="col-xs-12">
          {cards}
        </div>
      </div>
    </div>
  );
};

SavedVehicles.propTypes = propTypes;
SavedVehicles.defaultProps = defaultProps;

export default SavedVehicles;
